<template>
  <div class="col-12 col-md-12 col-lg-6">
    <div class="tit text-center">
       <h1>Contatos Pessoal</h1>
    </div>
    <div class="row justify-content-center">
      <div class="col-12 col-md-10 col-lg-8 col-xl-7">
        <form @submit="onSubmit">
          <div class="form-group text-left">
            <label for="Celular text-left">Celular</label>
            <input class="form-control form-control-lg" v-focus v-model="pessoal.Celular" type="text" v-mask="'phone'" placeholder="(__) _____-____" title="(__) _____-____" pattern="(\(\d{2}\)|\d{2})\s?\d{5}[ -]?\d{4}" required/>
          </div>
          <div class="form-group text-left">
            <label>Telefone</label>
             <input class="form-control form-control-lg" v-model="pessoal.Telefone" type="text" v-mask="'phone'" placeholder="(__) _____-____" title="(__) _____-____" pattern="(\(\d{2}\)|\d{2})\s?\d{4,5}[ -]?\d{4}"/>
          </div>
          <div class="text-center fixedOptions">
            <button class="btn btn-primary">Próximo <img src="../../assets/images/angle-right.svg"></button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pessoal: this.currentUser.Pessoal
    }
  },
  props: {
    currentUser: {required: true, type: Object}
  },
  methods: {
    onSubmit(e) {
      e.preventDefault()

      const newData = {Pessoal: this.pessoal}
      this.$emit('on-submit', newData)
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AdditionalInformationPersonalLoan/ContactsStep.vue